/**
 * In-memory access-token store (F1.2, non-negotiable).
 *
 * The access token lives ONLY in this module-scoped variable. It is NEVER
 * written to localStorage, sessionStorage, or document.cookie from JS. The
 * refresh token is an httpOnly cookie the browser holds and JS cannot read;
 * on a full page reload the access token is intentionally lost and recovered
 * via a silent refresh (see AuthContext bootstrap).
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function clearAccessToken(): void {
  accessToken = null;
}
